import { ColDef } from "ag-grid-community";
import { JiraTicketStatusCellRenderer } from "../column-def-cell-renderers/JiraTicketStatusCellRenderer";

export const jiraIssuesColumnDef: ColDef = {
  minWidth: 210,
  sortable: false,
  field: "resource.issues",
  headerName: "JIRA Status",
  cellRenderer: JiraTicketStatusCellRenderer,
};
